import React from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';

import {reviewCheckinCheckoutDetailsSelector, roomPaxDetails} from '@ibibo/hotels-review-reducer';

const DurationBlockNew = () => {
  const {
    checkinDisplayDate,
    checkoutDisplayDate,
    checkinDisplayTime,
    checkoutDisplayTime,
  } = useSelector(reviewCheckinCheckoutDetailsSelector);

  const {totalPax, numberOfRooms, numberOfNights} = useSelector(roomPaxDetails);

  return (
    <DurationBlockWrapDiv>
      <DurationInnerWrapDiv>
        <CheckInOutOuterWrapDiv>
          <CheckInWrapSpan>Check In</CheckInWrapSpan>
          <CheckInWrapPara>{checkinDisplayTime}, {checkinDisplayDate}</CheckInWrapPara>
        </CheckInOutOuterWrapDiv>
        <CheckInOutOuterWrapDiv>
          <CheckInWrapSpan>Check Out</CheckInWrapSpan>
          <CheckInWrapPara>{checkoutDisplayTime}, {checkoutDisplayDate}</CheckInWrapPara>
        </CheckInOutOuterWrapDiv>
        <CheckInOutOuterWrapDiv>
          <CheckInWrapSpan>Guests</CheckInWrapSpan>
          <CheckInWrapPara>{`${totalPax} ${(totalPax > 1 && 'Guests') ||
            'Guest'}, ${numberOfRooms} ${(numberOfRooms > 1 && 'Rooms') ||
            'Room'} | ${numberOfNights} ${(numberOfNights > 1 && 'Nights') ||
            'Night'}`}</CheckInWrapPara>
        </CheckInOutOuterWrapDiv>
      </DurationInnerWrapDiv>
    </DurationBlockWrapDiv>
  );
};

export default DurationBlockNew;

const DurationBlockWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
`,
);

const DurationInnerWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  border-radius:${props.theme.misc.borderRadius.base}
  background:${props.theme.colors.blue.lightef};
  padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};

`,
);

const CheckInOutOuterWrapDiv = styled.div(
  props => `
  width: 33%;
  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  // margin-right:${props.theme.spacing.large.l25};
`,
);

const CheckInWrapSpan = styled.span(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  font-size:${props.theme.font.small.font10};
  color:${props.theme.colors.grey.base};
  text-transform: uppercase;
`,
);

const CheckInWrapPara = styled.p(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  font-size:${props.theme.font.base};
  color:${props.theme.colors.black.base};
  padding-top:${props.theme.spacing.small.s5};
  font-weight:bold;

`,
);
